import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';  

@Injectable({
  providedIn: 'root'
})
export class EncryptService {

  private key = 'woodtech';

  constructor() { }

  encrypt(value: string){
    let encryptedValue : string;
    encryptedValue = CryptoJS.AES.encrypt(value.trim(), this.key.trim()).toString();
    return encryptedValue;
  }

  decrypt(value: string){
    let decryptedValue : string;
    decryptedValue = CryptoJS.AES.decrypt(value.trim(), this.key.trim()).toString(CryptoJS.enc.Utf8);
    return decryptedValue;
  }
}
